import { gql } from '@apollo/client';

export const UPDATE_USER_ADDITIONAL_DATA_MUTATION = gql`
  mutation updateUserAdditionalData($input: UserAdditionalDataInput!) {
    updateUserAdditionalData(input: $input) {
      correlationId
    }
  }
`;
